import { getAxios, patchAxios, postAxios} from 'services/api/api.service';
import { apiNames } from "services/api/endpoint.service";
import {  formatNumber, formatPrice, formatPriceNumber, getPricePerTime, getStops, getTimeBetween, TripDetail } from 'services/util/trips.service';
import { switchTransports, getActionLiteral, ETransportLiterals } from '../TripSelector/TripSelector.service';
import { RenfeTrainCodesList } from '../TripSelector/TripSelector.util';
import { IBooking, IData, IJourney, ITraveller, ITrip, TripCardList, IFareSetItem, Leg, ETypeTransport, IActivity, ActivityCardList, IDetailActivity, IDetailRenting, IRentingCardList, SummaryType } from './MyTrips.model';

import { deleteAxios } from 'services/api/api.service';
import * as mocks from "./MyTrips.mock";
import { _cancelDeleteButton } from './functions/manageDelete';
import { includedMainText } from '../TripSelector/functions/managePricetag';
import { manageTransbordosCercanias } from '../TripSelector/renfe.service';
import { mappedLanguageId } from 'pages/public/TmbNightBusFlow/TmbNightBusFlow.util';

import { literalExtrasConverter } from '../AveFlow/AveFlow.util';
import { filterRenfeTrip, formatCompleteDateToLiteral, formatDateAndMonthToLiteral, formatTimeToLiteral, formatTimeToLiteralUTC, getDiscount, getDiscountCancellationData, isFinalized, mappindDesglose, mappingPaymentCards, statusMapping, stylesStatusMapping, TMBStatusMapping, travelsType } from './MyTrips.util';
import { extractValueByKey, getRealTimeTrains, transformDateIncidents } from './TrainsIncidents/TrainsIncidents.util';




/**
 * @description get trip list
 * @param callback 
 * @param errorCallback 
 */
export function getTripListCall(chronology: string,page:string, callback: Function, errorCallback: Function, sort: string, mock?: any) {
  // [chronology: PAST or TODAY or FUTURE or TODAY,FUTURE]
  if (mock === "true") {
    const mockData = mocks.responseMoviTaxiBolt;
    try {
      sessionStorage.setItem("raas-trip-mock-data", JSON.stringify(mockData));
    } catch (error) {
      sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
    }
    callback(mockData);
  } else {
    // Conditional logic to modify the API endpoint
    let apiWithParams;
    if (chronology === "PAST") {
      apiWithParams = `/bookings?sort=${sort}(DATETIME)&chronology=${chronology}&providers=TRIP_PROVIDERS,TMB,GLOBICK,SIXT&page=${page}&limit=4`;
    }else if(chronology === "TODAY"){
      apiWithParams = `/bookings?sort=${sort}(DATETIME)&chronology=${chronology}&providers=TRIP_PROVIDERS,TMB,GLOBICK,SIXT&page=${page}&limit=2`;
    } else {
      apiWithParams = `/bookings?sort=${sort}(DATETIME)&chronology=${chronology}&providers=TRIP_PROVIDERS,TMB,GLOBICK,SIXT&page=${page}&limit=3`;

    }
    getAxios(apiNames.BKING, true, apiWithParams)
      .then((data: any) => {
        callback(data);
      })
      .catch((error: any) => {
        errorCallback(error);
      });
  }
}
/**
 * @description Get ITrips bookings data
 * @param {IData} data 
 * @returns {Array<{ outwardJourney: ITrip, returnJourney: ITrip }>} 
 */
export function getBookingsTripData(data: IData): Array<{ outwardJourney: ITrip, returnJourney: ITrip, travellers: Array<ITraveller>, chronology: string }> {
  const bookings: Array<IBooking> = data?.bookings;
  /* No hay reservas */
  if (!bookings || bookings?.length === 0) {
    return [];
  }
  /* Hay reservas */
  let arrayBookings: any[] = [];
  bookings.forEach((book: IBooking) => {
    const outwardJourney: ITrip | undefined = book?.outwardJourney?.trip ? book.outwardJourney.trip : undefined;
    const returnJourney: ITrip | undefined = book?.returnJourney?.trip ? book.returnJourney.trip : undefined;
    const travellers: Array<ITraveller> = book?.travellers;
    const chronology: string = book?.chronology;
    arrayBookings.push({ outwardJourney, returnJourney, travellers, chronology })
  });
  return arrayBookings;
}
/**
 * @description Get IJourneys bookings data
 * @param {IData} data 
 * @returns {Array<{ outwardJourney: IJourney, returnJourney: IJourney }>} 
 */
export function getBookingsJourneyData(data: any): Array<{ outwardJourney: IJourney, returnJourney: IJourney, travellers: any, idJourney: number }> {
  const bookings = data;
  /* No hay reservas */
  if (!bookings || bookings?.length === 0) {
    return [];
  }
  /* Hay reservas */
  let arrayJourneys: any[] = [];
  /*bookings.forEach((book: IBooking) => {
    const travellers = book.travellers;
    const outwardJourney: IJourney | undefined = book?.outwardJourney ? book.outwardJourney : undefined;
    const returnJourney: IJourney | undefined = book?.returnJourney ? book.returnJourney : undefined;
    const idJourney: number = book?.id;

    arrayJourneys.push({ outwardJourney, returnJourney, travellers, idJourney })
  });*/
  const travellers = bookings?.travellers;
  const outwardJourney: IJourney | undefined = bookings?.outwardJourney ? bookings.outwardJourney : undefined;
  const returnJourney: IJourney | undefined = bookings?.returnJourney ? bookings.returnJourney : undefined;
  const idJourney: number = bookings?.id;

  arrayJourneys.push({ outwardJourney, returnJourney, travellers, idJourney })
  return arrayJourneys;
}
/**
 * @description Cancel trip
 * @param callback 
 * @param errorCallback 
 */
export function cancelTrip(data: { orderid: string, body?: any }, callback: Function, errorCallback: Function) {
  const api = `/journeys/${data.orderid}`;
  const body = data.body;
  deleteAxios(apiNames.BKING, true, api, undefined, { data: body }).then((data: any) => {
    callback(data);
  }).catch((error: any) => {
    errorCallback(error)
  })
}
/**
 * @description Delete Leg (PST) from LegList.
 * @param callback 
 * @param errorCallback 
 */
export function deletePSTBooking(data: { tripid: string, body?: any }, callback: Function, errorCallback: Function) {
  const api = `/journeys/trips/${data.tripid}`;
  const body = data.body;
  deleteAxios(apiNames.BKING, true, api, undefined, { data: body }).then((data: any) => {
    callback(data);
  }).catch((error: any) => {
    errorCallback(error)
  })
}

/**
 * @description Delete Leg (PST) from LegList.
 * @param callback 
 * @param errorCallback 
 */
export function deletePSTAVEBooking(data: any, callback: Function, errorCallback: Function) {
  const api = `/partial-cancellation/orders/${data.orderId}/bookings/${data.idBooks[0]}`;
  const body = {
    "reason": "Test Cancel",
    "parameters": {
      "entitlementIds":[data.ticketId]
       
    }
  };

  postAxios(apiNames.BKING, true, api, body).then((data: any) => {
    callback(data);
  }).catch((error: any) => {
    errorCallback(error)
  })
}

/* TRIP-CARD-LIST COMPONENT*/
export function getTripCardComponentData(data: IData, isPastTravel = false, t: any): Array<{ outwardJourney: TripCardList, returnJourney: TripCardList }> {
  const bookings: Array<IBooking> = data.bookings;
  const result: Array<any> = [];
  bookings.forEach((book: IBooking, i: number) => {
    if (book.outwardJourney?.renting) {
        result.push({
        outwardJourney: getRentingCardData(book, t),
        purchaseType: travelsType.SIXT
      })
    }
    else if (book.outwardJourney?.activity) {
        result.push({
        travellers: book.travellers.length,
        outwardJourney: getActivityCardData(book, book.outwardJourney.activity, book.outwardJourney?.selectedTariff, t),
        purchaseType: travelsType.TMB
      })
    }
    else if (book.outwardJourney?.experience){
      result.push({
        travellers: book.travellers.length,
        outwardJourney: getExperienceCardData(book, book.outwardJourney.experience, book.outwardJourney?.selectedTariff, t),
        purchaseType: travelsType.GLOBICK
      })
    }else if(book.outwardJourney?.trip){
      result.push({
        travellers: book.travellers,
            outwardJourney: isPastTravel ? 
            getPastTripCards(book, book.outwardJourney?.trip, book.outwardJourney?.selectedTariff, t) :
            getTripCardData(book, book.outwardJourney.trip, book.outwardJourney?.selectedTariff, t),
            returnJourney: book?.returnJourney
                ? isPastTravel
                ? getPastTripCards(book, book.returnJourney?.trip, book.returnJourney?.selectedTariff, t)
                : getTripCardData(book, book.returnJourney?.trip, book.returnJourney?.selectedTariff, t)
                : undefined,
                purchaseType: travelsType.TRIP
            })   
    }

  });
  return result;
}

function getPastTripCards(book: IBooking, trip: ITrip, selectedTarif: any, t: any) {
  /* Apaño rápido y provisional por falta de Leg en ida vuelta ave. */
  if (Array.isArray(trip.LegList) && !trip.LegList.Leg) {
    const LegList = {
      Leg: [...trip.LegList]
    };
    trip.LegList = LegList;
  }
  let statusCard = {} as any;
  statusCard = getStatusCard(selectedTarif, t)
  let isCooltra=selectedTarif?.find((item:any) => item?.provider == "cooltra");

  const isValidTrip = trip.isValidTrip;
  if (isValidTrip === false) {
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "warning";
    statusCard.canceled = true;
  }
  let dest=""
  if(trip?.Destination !== undefined){
    dest=trip?.Destination?.name
  }else if(trip?.Destination === undefined &&isCooltra.provider==="cooltra" ){
    dest=t("desgloseModalLiterals.endCooltra");
  }

let arrivalDate
  if(book.returnJourney){
    arrivalDate=
      arrivalDate=trip?.Destination!==undefined ? formatDateAndMonthToLiteral(book.returnJourney.trip.Destination.date):"-"
  }else{
   arrivalDate=trip?.Destination!==undefined ? formatDateAndMonthToLiteral(trip?.Destination?.date):"-"
  }
  return {
    //dest: trip?.Destination?.name,
    dest: dest,
    location: "",
    price: `${formatPrice(book?.price?.total / 100)} €`,
    orderid: String(book?.id),
    departureDate: trip?.Destination!==undefined ?  formatDateAndMonthToLiteral(trip?.Destination?.date) : "-",
    arrivalDate:arrivalDate,
    numpassengers: book.travellers.length.toString(),
    returnticket: !!book?.returnJourney,
    literals: {
      fromto: t("getTripCardData.literals.roundtrip"),
      cancelation: statusCard.literalCancelation,
      titleTag  :t("getTripCardData.literals.tagTrips"),
    },
    cancelation: statusCard.canceled,
    status: statusCard.status,
    purchaseType: travelsType.TRIP
  }
}

function getTripCardData(book: IBooking, trip: ITrip, selectedTarif: any, t: any): TripCardList {
  /* Apaño rápido y provisional por falta de Leg en ida vuelta ave. */
  if (Array.isArray(trip.LegList) && !trip.LegList.Leg) {
    const LegList = {
      Leg: [...trip.LegList]
    };
    trip.LegList = LegList;
  }

  const dest = trip?.Destination?.name.split(',')[1];
  const location = trip?.Destination?.name.split(',')[0];
  const departureTime = trip?.Origin?.time.split(':');
  const arrivalTime = trip?.Destination?.time.split(':');
  let statusCard = {} as any;
  statusCard = getStatusCard(selectedTarif, t);

  const isValidTrip = trip.isValidTrip;
  const containCancelledStops = trip?.LegList?.Leg?.findIndex(item => item?.isValidLeg === false);
  if (isValidTrip === false || containCancelledStops !== -1) {
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "warning";
    statusCard.canceled = true;
  }

  let trasportSection = getTransportSection(trip?.LegList?.Leg, getNameKarhoo(book, trip, true))


  //let transportsArray = trasportSection.map((item: any) => ({ ...item, text: item.text?.toLowerCase() == 'karhoo' ? item.transportTypeString : item.text }))
  
  trasportSection = filterWalkingCards(trasportSection);

  return {
    dest: dest ? dest : location,
    location: dest ? location : '',
    date: formatDateAndMonthToLiteral(trip?.Destination?.date.replace(/-/g, '/')),
    orderid: trip?.Destination?.extId,
    departureTime: departureTime ? `${departureTime[0]}:${departureTime[1]}` : '',
    arrivalTime: arrivalTime ? `${arrivalTime[0]}:${arrivalTime[1]}` : '',
    numpassengers: book.travellers.length.toString(),
    transports: { transportSection: trasportSection }, // iconografía de transportes
    returnTicket: book.returnJourney ? JSON.stringify(book.returnJourney) !== '{}' : false,
    fromdone: isFinalized(book.outwardJourney.destinationDate),
    currentTrip: book.outwardJourney.inProgress,
    todayTrip: book.chronology == "TODAY",
    literals: {
      moreText: t("getTripCardData.literals.moreText"),
      from: t("getTripCardData.literals.from"),
      to: t("getTripCardData.literals.to"),
      current: t("getTripCardData.literals.current"),
      today: t("getTripCardData.literals.today"),
      finalized: t("getTripCardData.literals.finalized"),
      cancelation: statusCard.literalCancelation
    },
    cancelation: statusCard.canceled,
    status: statusCard.status,
    isValidTrip,
    chronology: book.chronology,
    purchaseType: travelsType.TRIP
  }
}

function getActivityCardData(book: IBooking, activity: IActivity, selectedTarif: any, t: any): ActivityCardList {    
    const nameActivity = activity.name;
    const idActivity = book.id.toString();
    const chronology = book.chronology;
    const currentTrip = book.outwardJourney.inProgress;
    const price = book?.price.total;
    const imgActivity = activity.details.url;
    const stylesTagStatus = stylesStatusMapping(book.outwardJourney.selectedTariff[0].tickets[0].status);
    const date = formatDateAndMonthToLiteral(activity?.activityDate);

    return {
      literals: {
        titleTag  :t("getTripCardData.literals.tagTMB"),
        diffDayLiterals:"día",
        diffDaysLiterals: "días"
      },
        name: nameActivity,
        //idActivity: idActivity,
        idActivity:selectedTarif[0].orderId,
        status: book.outwardJourney.selectedTariff[0].tickets[0].status,
        statusActivity: statusMapping(book.outwardJourney.selectedTariff[0].tickets[0].status,t),
        departureTime: book?.outwardJourney?.activity?.session,
        colorStatusActivity: stylesTagStatus.color,
        borderStatusActivity: stylesTagStatus.border,
        backgroundStatusActivity: stylesTagStatus.background,   
        chronology: chronology,
        currentTrip: currentTrip,
        purchaseType: travelsType.TMB,
        price:`${formatPrice(price / 100)} €`,
        cancelation:false,
        passengers: book.outwardJourney?.activity?.numberOfVouchers,
        //Pendiente de confirmar con servicio
        date: date,
        language:book?.outwardJourney?.selectedTariff[0]?.tickets[0]?.language,
        img: imgActivity,
        orderid:selectedTarif[0].orderId,
        electronicCode:activity?.voucher?.electronicCode
    }
  }

  function getExperienceCardData(book: IBooking, experience: any, selectedTarif: any, t:any): any {
    const stylesTagStatus = stylesStatusMapping(book.outwardJourney.selectedTariff[0].tickets[0].status);

    return {
      literals: {
        titleTag  :t("getTripCardData.literals.tagTMB")        
      },
        name: experience.name,
        idActivity: book?.outwardJourney?.selectedTariff[0]?.tickets[0]?.offerId,
        status: book.outwardJourney.selectedTariff[0].tickets[0].status,
        departureTime: book?.outwardJourney?.experience?.session,
        date: formatDateAndMonthToLiteral(experience.activityDate),
        statusActivity: statusMapping(book.outwardJourney.selectedTariff[0].tickets[0].status,t),
        colorStatusActivity: stylesTagStatus.color,
        borderStatusActivity: stylesTagStatus.border,
        backgroundStatusActivity: stylesTagStatus.background,          
        chronology: book.chronology,
        currentTrip: book.outwardJourney.inProgress,
        purchaseType: travelsType.GLOBICK,
        price:`${formatPrice(book?.price.total / 100)}  €`,
        cancelation:false,
        passengers: (book?.travellers.length).toString(),
        sessionDate:book?.outwardJourney?.experience?.activityDate,
        language:"ESP",
        image: book?.outwardJourney?.experience?.imageUrl
    }
  }

  function getRentingCardData(book: IBooking, t:any): IRentingCardList {   
    const renting = book.outwardJourney.renting; 

    const idActivity =  book?.outwardJourney?.renting?.reference;
    const stylesTagStatus = stylesStatusMapping(book?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status);
    const price = `${formatPrice(book.price.total / 100)}  €`;

    return {
      literals: {
        titleTag: t("getTripCardData.literals.tagSixt"),
      },
      name: renting?.vehicle?.name,
      carStyle: renting?.vehicle?.model, 
      date: formatDateAndMonthToLiteral(renting.collection.dateLocation), 
      collectionDate: formatDateAndMonthToLiteral(renting.collection.dateLocation),        
      chronology: book.chronology,
      purchaseType: travelsType.SIXT,
      idActivity: idActivity,
      durationDay: renting?.devolution?.durationDay,
      image: renting.vehicle?.imageUrl,
      status: book.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,   
      statusActivity: statusMapping(book.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,t),
      colorStatusActivity: stylesTagStatus?.color,
      borderStatusActivity: stylesTagStatus?.border,
      backgroundStatusActivity: stylesTagStatus?.background,       
      price: price,
    }
  }

function getTicketsStatus(element: any, t: any,paymentStatus:string) {
  let countFailed = 0;
  let countPending = 0;
  let countCanceled = 0;
  let countNonRefunded = 0;
  let countStocked = 0;
  let countValid = 0;
  let countByProvider = 0;
  let statusCard = { literalCancelation: "", status: "", canceled: false };
  /*if (element == "FAILED") countFailed++;
  if (element == "PENDING") countPending++;
  if (element == "CANCELED") countCanceled++;*/
  element.forEach((ticket: any) => {
    if (ticket.status == "FAILED") countFailed++;
    if (ticket.status == "PENDING") countPending++;
    if (ticket.status == "CANCELED") countCanceled++;
    if (ticket.status == "CANCELED_NON_REFUNDED") countNonRefunded++;
    if (ticket.status == "STOCKED") countStocked++;
    if (ticket.status == "VALID") countValid++;
    if (ticket.status == "CANCELED_BY_PROVIDER") countByProvider++;
     if (ticket.status == "CANCELED_NO_CHARGE") countByProvider++;
     if (ticket.status == "CANCELED_NOT_USED") countByProvider++;
    
    
  });
  //Solo mostramos el mensaje si todos los tickets estan cancelados. 

  if (element.length == countFailed) {
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "canceled";
    statusCard.canceled = true;
  } else if (countPending > 0) {
    statusCard.literalCancelation = t("getTripCardData.literals.tripRoutesPendingAcceptance");
    statusCard.status = "waiting";
    statusCard.canceled = true;
  } else if (element.length == countCanceled) {
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "warning";
    statusCard.canceled = true;
  }else if(element.length == countNonRefunded){
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "canceled_non_refunded";
    statusCard.canceled = true;
    
  }else if(element.length == countStocked){
    statusCard.literalCancelation = "";
    statusCard.status = "countStocked";
    statusCard.canceled = false;
  }else if(element.length == countByProvider){
    statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
    statusCard.status = "warning";
    statusCard.canceled = true;
  }
  /*else if(element.length == countValid){
    statusCard.literalCancelation = paymentStatus==="SUCCESS" ?t("getTripCardData.literals.tripValidSuccess"):t("getTripCardData.literals.tripValid");
    statusCard.status = "valid";
    statusCard.canceled = true;
    
  }*/
  
  return statusCard;
}

function getStatusCard(tarifas: any, t: any) {
  let statusCard = { literalCancelation: "", status: "", canceled: false };

    tarifas?.forEach((element: any) => {
      if (!!element.status) {
        statusCard = getTicketsStatus(element.tickets, t,element.paymentInfo?.ccType)
      } else {
        if (element.status == "BOOKED") {
          statusCard.literalCancelation = "";
          statusCard.status = "";
          statusCard.canceled = false;
        }
        else if (element.status == "CANCELED") {
          statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
          statusCard.status = "warning";
          statusCard.canceled = true;
        }
        else if (element.status == "PENDING") {
          statusCard.literalCancelation = t("getTripCardData.literals.tripRoutesPendingAcceptance");
          statusCard.status = "waiting";
          statusCard.canceled = true;
        }
        else if (element.status == "FAILED") {
          statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
          statusCard.status = "canceled";
          statusCard.canceled = true;
        }
        else if (element.status == "VALID") {
          statusCard.literalCancelation = t("getTripCardData.literals.tripCanceledRoutes");
          statusCard.status = "valid";
          statusCard.canceled = true;
        }
      }

    });

  

  return statusCard;
}


/* M-DETAIL-ROUTE COMPONENT */
export function getTripDetailRouteComponentData(data: any, t: any, isPastTravel = false,t2:any): Array<{ outwardJourney: any, returnJourney: any }> {
  const journeys: Array<{ outwardJourney: IJourney, returnJourney: IJourney, travellers: any, idJourney: number }> = getBookingsJourneyData(data);
  const array: Array<any> = [];
  journeys.forEach(({ outwardJourney, returnJourney, travellers, idJourney }) => {    
        array.push({
          outwardJourney: getTripDetailRouteData('OUTWARD', idJourney, outwardJourney?.trip, mapContextsBooked(outwardJourney), travellers, outwardJourney?.selectedTariff, t, isPastTravel,outwardJourney.inProgress,t2),
          returnJourney: returnJourney?.trip ? getTripDetailRouteData('RETURN', idJourney, returnJourney?.trip, mapContextsBooked(returnJourney), travellers, returnJourney?.selectedTariff, t, isPastTravel,t2) : undefined,
        })
     
  });
  return array;
}

export function getDetailActivityFromBooking(booking: IBooking,t:any,t4:any,chronology:string): any {
        
    const priceTickets = `${booking?.price?.total ? formatPrice(booking?.price?.total / 100) : 0} €`;
    const priceTicketsTotal = `${booking?.price?.totalWithOutConcepts ? formatPrice(booking?.price?.totalWithOutConcepts / 100) : 0} €`;
   
    const printDate = new Date(booking.outwardJourney.activity?.voucher?.validityEndDatetime);    
      let variantSummary=""
      if(booking.outwardJourney.activity.catalogueId==="night-tour" || booking.outwardJourney.activity.catalogueId==="xmas-tour"){
        variantSummary=SummaryType.MYSCHEDULEDACTIVITIES
      }else{
        variantSummary=SummaryType.MYACTIVITIES
      }
    const {discounts,discountsNoString}=getDiscountCancellationData(booking,false)
    const tariff=booking?.outwardJourney?.selectedTariff[0]
    let payment
    if(tariff?.paymentInfo){
      payment=mappingPaymentCards(tariff?.paymentInfo,tariff.status,tariff?.provider,tariff?.price,tariff?.orderFailedReason,t)
    }
    const bookingData: IDetailActivity = {
        idBooking: booking.id, 
        orderId:booking.outwardJourney.selectedTariff[0].orderId,
        idActivity: booking.outwardJourney.activity.catalogueId,
        activityInfo: booking.outwardJourney?.activity?.details?.details,
        name: booking.outwardJourney.activity.name,
        electronicCode:booking?.outwardJourney?.activity?.voucher?.electronicCode,
        variantSummary:variantSummary,
        activitySummary: { 
            numbersTravellers: booking.outwardJourney?.activity?.numberOfVouchers,
            price: priceTicketsTotal,
            statusId: booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,
            statusActivity: statusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,t),
            backgroundStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).background as any,
            colorStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).color,
            borderStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).border as any,
            language:booking?.outwardJourney?.activity?.languages?.map((o: any) => mappedLanguageId(o,t4)).join(' ')|| '',
            //bookingTime:formatDateAndMonthToLiteral(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.bookingTime as any),
            bookingTime:formatDateAndMonthToLiteral(booking?.outwardJourney?.originDate as any),
            createdDate: formatDateAndMonthToLiteral(booking?.createdDate),
            timeCreated: formatTimeToLiteral(booking?.createdDate),
            totalPrice: priceTickets,
            idBook: booking.outwardJourney?.selectedTariff[0]?.tickets[0].idBook,
            orderId: booking.outwardJourney?.selectedTariff[0]?.orderId,
            urlReceipt: booking.outwardJourney?.selectedTariff[0]?.tickets[0].invoiceDownloadUrl,
            discount:discounts?discounts :"",
            discountsNoString:discountsNoString?discountsNoString:undefined,
            electronicCode:booking?.outwardJourney?.activity?.voucher?.electronicCode,
            voucherSequenceNumber: 0,
            literalStatus:TMBStatusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status, booking.outwardJourney?.selectedTariff[0]?.paymentInfo?.paymentStatus,t),
            showBannerDiscount:booking?.outwardJourney?.selectedTariff[0]?.price?.concepts[0]?.redemptionTime ? false:true,
            literalBannerDiscount: t("getTripCardData.literals.noApplyDiscount"),
            chronology:booking.chronology,
            ...(payment ? { paymentCard:{...payment,isPastTravel:chronology==="myTrips"?false:true} } : {})
        },
        activityValidationTicket: {
            idActivity: booking.outwardJourney.activity.catalogueId,
            issueDate: formatCompleteDateToLiteral(booking.outwardJourney.activity?.voucher?.validityStartDatetime),
            printValidityDate: formatCompleteDateToLiteral(printDate),
            isTravelCard: booking.outwardJourney.activity.catalogueId === "holabarcelona-travel-card",
            qrCode: booking?.outwardJourney?.activity?.voucher?.electronicCode
        }
    }
    return bookingData
} 

export function getDetailExperienceFromBooking(booking: IBooking,t:any,chronology:string): any {
  const priceTickets = `${booking?.price?.total ? formatPrice(booking?.price?.total / 100) : 0} €`;


  const printDate = new Date(booking.outwardJourney.experience.transactionDate);    
  printDate.setDate(printDate.getDate() + 1);
  const tariff=booking?.outwardJourney?.selectedTariff[0]
  let payment
  if(tariff?.paymentInfo){

    payment=mappingPaymentCards(tariff?.paymentInfo,tariff.status,tariff?.provider,tariff?.price,tariff?.orderFailedReason,t)
  }
  const bookingData: any = {
      idBooking:booking.outwardJourney.selectedTariff[0].orderId, //booking.outwardJourney.experience.referenceNumber, 
      idActivity:booking.id,//booking.outwardJourney.experience.referenceNumber,      
      name: booking.outwardJourney?.experience?.name,
      activitySummary: { 
          numbersTravellers: booking.outwardJourney?.experience?.totalQuantity,
          price: priceTickets,
          statusId: booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,
          statusActivity: statusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,t),
          backgroundStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).background as any,
          colorStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).color,
          borderStatusActivity: stylesStatusMapping(booking.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).border,
          language:"ESP",
          bookingTime: booking?.outwardJourney?.experience?.session,
          createdDate: formatDateAndMonthToLiteral(booking?.createdDate),
          timeCreated: formatTimeToLiteral(booking.createdDate),
          totalPrice: priceTickets,
          idBook: booking.outwardJourney?.selectedTariff[0]?.tickets[0].idBook,
          orderId: booking.outwardJourney?.selectedTariff[0]?.tickets[0].offerId,
          date: formatDateAndMonthToLiteral(booking.outwardJourney?.experience?.activityDate),
          ...(payment?.number ? { paymentCard:{...payment,isPastTravel:chronology==="myTrips"?false:true} } : {})

      },
  }

  return bookingData
} 

export function getDetailRentingFromBooking(booking: IBooking,t:any): any {  

    const extrasList = booking?.outwardJourney?.renting?.vehicle.extras;
    const extrasTotalPrice = extrasList?.reduce((acc: any, item: any) => {
        return acc + item.amount;
      }, 0);
    const extrasFormatted =  formatPriceNumber(extrasTotalPrice);


    let extrasListVehicle = extrasList?.map((element: any) => {
        return {
          name: element.name,
          amount: formatPriceNumber(element.amount),
        };
      });
  
    const bookingData: IDetailRenting = { 
        reference: parseInt(booking?.outwardJourney?.renting?.reference),  
        idBook: booking.outwardJourney?.selectedTariff[0]?.tickets[0].idBook,
        orderId: booking.outwardJourney?.selectedTariff[0]?.orderId,  
        tripId: booking.id,   
        rentingSummary: { 
            statusId: booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,           
            rentingReservation: {
                collection: {
                        point: booking?.outwardJourney?.renting?.collection?.nameLocation,
                        date: formatDateAndMonthToLiteral(booking?.outwardJourney?.renting?.collection?.dateLocation),
                        time: formatTimeToLiteralUTC(booking?.outwardJourney?.renting?.collection?.dateLocation)
                    },
                devolution: {
                        point: booking?.outwardJourney?.renting?.devolution?.nameLocation,
                        date: formatDateAndMonthToLiteral(booking?.outwardJourney?.renting?.devolution?.dateLocation),
                        durationDay: booking?.outwardJourney?.renting?.devolution?.durationDay,
                        time: formatTimeToLiteralUTC(booking?.outwardJourney?.renting?.devolution?.dateLocation)
                    },
                statusRenting: statusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status,t),
                backgroundStatusRenting: stylesStatusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).background,
                colorStatusRenting: stylesStatusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).color,
                borderStatusRenting: stylesStatusMapping(booking?.outwardJourney?.selectedTariff[0]?.tickets[0]?.status).border,
             },
             rentingPriceSummary: {
                totalPrice: formatPriceNumber(booking?.price?.total),
                priceVehicle: formatPriceNumber(booking?.outwardJourney?.renting?.vehicle.total),
                priceKmsName: booking?.outwardJourney?.renting?.vehicle?.services[0]?.name,
                priceKms: formatPriceNumber(booking?.outwardJourney?.renting?.vehicle?.services[0]?.amount),
                priceInsuranceName: booking?.outwardJourney?.renting?.vehicle?.services[1]?.name,
                priceInsurance: formatPriceNumber(booking?.outwardJourney?.renting?.vehicle?.services[1]?.amount),
                priceExtras: extrasFormatted,
             },    
             rentingCreatedReservation: {
                date: formatDateAndMonthToLiteral(booking?.createdDate),
                time: formatTimeToLiteral(booking?.createdDate)
             }        
            },  
        rentingInfo: {
           vehicle:
                    {
                        carName: booking.outwardJourney.renting?.vehicle?.name,
                        image: booking.outwardJourney.renting?.vehicle?.imageUrl,
                        carStyle: booking.outwardJourney.renting?.vehicle?.model,
                        isAutomatic: booking.outwardJourney.renting?.vehicle?.isAutomatic,
                        isElectric: booking.outwardJourney.renting?.vehicle?.isElectric,
                        electricMaxRange: booking.outwardJourney.renting?.vehicle?.maxRangeKm,
                        bags: booking.outwardJourney.renting?.vehicle?.bags,
                        passengers: booking.outwardJourney.renting?.vehicle?.maxPassengers,
                        ageDriver: booking.outwardJourney.renting?.vehicle?.ageDriver,
                        totalForDay: formatNumber(booking.outwardJourney.renting?.vehicle?.totalForDay),
                        total: formatNumber(booking.outwardJourney.renting?.vehicle?.total),
                        kmsServices: {
                           name: booking.outwardJourney.renting?.vehicle?.services[0]?.name,
                           description: booking.outwardJourney.renting?.vehicle?.services[0]?.description,
                           amount: formatPriceNumber(booking.outwardJourney.renting?.vehicle?.services[0].amount)                        
                        },
                        insuranceServices: {
                            name: booking.outwardJourney.renting?.vehicle?.services[1]?.name,
                            description: booking.outwardJourney.renting?.vehicle?.services[1]?.description,
                            amount: formatPriceNumber(booking.outwardJourney.renting?.vehicle?.services[1]?.amount)                       
                        },
                        extras: extrasListVehicle
                     }                        
                    } 
        }      
    return bookingData
} 

export function cancelTMBActivity(
    orderId: string,
    idBooks: string,
    callback?: Function,
    errorCallback?: Function
  ) {   

const body = {
    idBooks: [
       idBooks
    ],
    parameters: [
      {
      key: "explanation",
      value: "Explicacion de cancelacion"
      }
    ]
}

const api = `/journeys/${orderId}`;
  deleteAxios(apiNames.BKING, true, api, undefined, { data: body }).then((data: any) => {

    if (callback) callback(data);
  }).catch((error: any) => {
    if (errorCallback) errorCallback(error);
  });
  }



export function usedTMBActivity(
    tripId: number,  
    callback?: Function,
    errorCallback?: Function
  ) {   


const api = `/bookings/tmb/ticket-used/${tripId}`;
  patchAxios(apiNames.BKING, true, api, undefined).then((data: any) => {

    if (callback) callback(data);
  }).catch((error: any) => { 
    if (errorCallback) errorCallback(error);
  });
  }

  export function cancelSixtActivity(
    tripId: number,
    orderId: string,
    idBooks: string,
    callback?: Function,
    errorCallback?: Function
  ) {   

const body = {
    idx: 0,
    direction: "OUTWARD",
    orderId: orderId,
    idBooks: [idBooks]
}

const api = `/journeys/trips/${tripId}`;
  deleteAxios(apiNames.BKING, true, api, undefined, { data: body }).then((data: any) => {

    if (callback) callback(data);
  }).catch((error: any) => {
    if (errorCallback) errorCallback(error);
  });
  }

function isCercaniasAveButton(trip: any, icon: string, books?: any) {

  if (trip !== undefined && (icon == 'cercanias' || icon == 'ave') && !!books) {
    return [{
      "type": "button",
      "styleButton": "outline",
      "id": icon,
      "bookings": books,
      "text": "Ver billete",
      "class": "col-auto align-self-start"
    },
    {
      "type": "button",
      "styleButton": "link",
      "id": "cancelTrip",
      "text": "Cancelar trayecto",
      "class": "col-auto align-self-end"
    }]
  } else return []
}

function getPriceTag(icon: any, aproxPrice?: any, t?: any, cercaniasWithNotes = false, getStatusTrip?: any) {
  let tariffObject = { type: "", text: "", isExternal: false, showIcon: false, aprox: false, price: 0,priceTotal:0 };
  switch (icon) {
    case "busLD":
      tariffObject.type = "warn";
      tariffObject.text = t("getTripCardData.literals.requiresExternalPurchase");
      // tariffObject.text = `${t('getTripCardData.literals.requiresExternalPurchase')} (${tariffObject.price ? formatPrice(tariffObject.price) + '€' : t('getTripCardData.literals.requiresExternalPurchase')})`; // t("getTripCardData.literals.requiresExternalPurchase");
      tariffObject.isExternal = true;
      tariffObject.showIcon = true;
      tariffObject.aprox = false;
      break;
    case "busUrb":
      tariffObject.type = "warn";
      tariffObject.text = t("getTripCardData.literals.requiresExternalPurchase");
      // tariffObject.text = `${t('getTripCardData.literals.requiresExternalPurchase')} (${tariffObject.price ? formatPrice(tariffObject.price) + '€' : t('getTripCardData.literals.requiresExternalPurchase')})`; // t("getTripCardData.literals.requiresExternalPurchase");
      tariffObject.isExternal = true;
      tariffObject.showIcon = true;
      tariffObject.aprox = false;
      break;
    case "metro":
      tariffObject.type = "warn";
      tariffObject.text = t("getTripCardData.literals.requiresExternalPurchase");
      // tariffObject.text = `${t('getTripCardData.literals.requiresExternalPurchase')} (${tariffObject.price ? formatPrice(tariffObject.price) + '€' : t('getTripCardData.literals.requiresExternalPurchase')})`; // t("getTripCardData.literals.requiresExternalPurchase");
      tariffObject.isExternal = true;
      tariffObject.showIcon = true;
      tariffObject.aprox = false;
      break;
    case "cercanias":
      if (cercaniasWithNotes) {
        tariffObject.type = "warn";
        tariffObject.text = t("getTripCardData.literals.requiresExternalPurchase");
        tariffObject.isExternal = true;
        tariffObject.showIcon = true;
        tariffObject.aprox = false;
      } else {
        tariffObject.type = "info";
        tariffObject.text = t("getTripCardData.literals.includedMainTicket");
      }

      break;
    case "ave":
      tariffObject.type = "info";
      tariffObject.text = t("getTripCardData.literals.notAvailable");
      break;
    case "patinete":
      tariffObject.type = "info";
      tariffObject.text = getStatusTrip.canceled == true ? `0 €` : `${aproxPrice} €`;
      tariffObject.isExternal = true;
      tariffObject.showIcon = false;
      tariffObject.aprox = true;
      tariffObject.price = parseFloat((getStatusTrip.canceled == true ? '0' : aproxPrice).replace(',', '.'));
      tariffObject.priceTotal = parseFloat((getStatusTrip.canceled == true ? '0' : aproxPrice).replace(',', '.'));

      break;
    case "moto":
      tariffObject.type = "info";
      tariffObject.text = getStatusTrip.canceled == true ? `0 €` : `${aproxPrice} €`;
      tariffObject.isExternal = true;
      tariffObject.showIcon = false;
      tariffObject.aprox = true;
      tariffObject.price = parseFloat((getStatusTrip.canceled == true ? '0' : aproxPrice).replace(',', '.'));
      tariffObject.priceTotal = parseFloat((getStatusTrip.canceled == true ? '0' : aproxPrice).replace(',', '.'));
      break;
    case "taxiVtc":
      tariffObject.type = "info";
      tariffObject.text = Number.isNaN(parseFloat((aproxPrice).replace(',', '.'))) ? t("getTripCardData.literals.rateAvailable") : `${aproxPrice} €`;
      tariffObject.isExternal = true;
      tariffObject.showIcon = false;
      tariffObject.aprox = true;
      tariffObject.price = (Number.isNaN(parseFloat((aproxPrice).replace(',', '.'))) ? 0 : parseFloat((aproxPrice).replace(',', '.')));
      tariffObject.priceTotal = parseFloat((getStatusTrip.canceled == true ? '0' : aproxPrice).replace(',', '.'));
      break;
    default:
      break;
  }
  return tariffObject;
}

function getAproxPrices(name?: string, trip?: any, id?: any) {

  let numberPrice = 0;
  let aproxPrice = "";
  switch (name) {
    case "cooltra":
      let coltraPrice = getPriceFromCooltra(trip, id);
      numberPrice = coltraPrice / 100;
      aproxPrice = formatPrice(numberPrice)
      break;
      case "tier":
        let tierPrice = getPriceFromCooltra(trip, id);
        numberPrice = tierPrice / 100;
        aproxPrice = formatPrice(numberPrice)
        break;
    case "Reby eScooter":
      let rebyPrice = getPriceFromCooltra(trip, id);
      numberPrice = rebyPrice / 100;
      aproxPrice = formatPrice(numberPrice)
      break;
    case "reby-escooter":
      let rebyPriceApp = getPriceFromCooltra(trip, id);
      numberPrice = rebyPriceApp / 100;
      aproxPrice = formatPrice(numberPrice)
      break;

    default:
      break;
  }
  return aproxPrice;
}

function getPriceFromCooltra(trip?: any, id?: any): number {
  let finalPrice = 0;

  trip?.TariffResult?.fareSetItem.forEach((element: any) => {

    if (element.fromLegId == id ||element.fromLeg == id ) finalPrice = element.fareItem[0]?.ticket[0]?.price
  });

  return finalPrice
}

function getTravellers(tarifas: any, travellers: any) {
  const newTravellers: any[] = [];

  if (!!tarifas.tickets) {
    tarifas?.tickets?.map((item: any, numticket: number) => {
      newTravellers.push({
        ...travellers[numticket],
        bookID: item?.idBook,
        docoTicketId:item?.docoTicketId,
        status:item?.status
      })
    })
  }

  return newTravellers;
}



const getTransportType = (el: any) => {
  let { icon } = switchTransports(el);
  const informativeTransportsArray = ['metro', 'busLD'];
  const paidTransportsArray = ['cercanias', 'ave', 'taxiVtc'];
  if (informativeTransportsArray.includes(icon)) {
    return ETypeTransport.info;
  }
  else if (paidTransportsArray.includes(icon)) {
    return ETypeTransport.paid;
  }
  else return ETypeTransport.none;
}

function getTripDetailRouteData(directionTrip: string, idJourney: number, trip: ITrip, contextsBooked: Array<string>, travellers: any, selectedTarif?: Array<any>, t?: any, isPastTravel = false, inProgress?:any,t2?:any) {
  let output: TripDetail[] = [];
  let tarifs: any[] = [];
  /* Apaño rápido y provisional por falta de Leg en ida vuelta ave. */
  if (directionTrip == 'RETURN' && Array.isArray(trip?.LegList) && !trip?.LegList?.Leg) {
    const LegList = {
      Leg: [...trip.LegList]
    };
    trip.LegList = LegList;
  }

  if (trip?.TariffResult?.fareSetItem) {
    tarifs = getTarifs(trip?.TariffResult?.fareSetItem, contextsBooked);
  }

  const TariffMap = _getTarifMap(selectedTarif,t,directionTrip,t2);
  const TicketsMap = _getTicketsMap(travellers, selectedTarif,t);

  const deleteButtonsActions = _cancelDeleteButton(trip);

  let nameTransport = "";

  trip?.LegList?.Leg.forEach((el: any, index: number) => {
    if(el.name==="cooltra" && el.Destination=== undefined){
      return null
    }

    let { originHour, originMinutes, destinationHour, destinationMinutes, diff } = getTimeBetween(el);
    let line = switchTransports(el); // ANA refactor
    let { icon, transportTypeString } = switchTransports(el, 0, nameTransport);
    let isWalk: boolean = (icon == "andar" || icon == "transbordo" || icon == "ingreso");
    let isCooltra: boolean = (icon == "moto");
    let freq = el.Freq ? `${Math.round((el.Freq.waitMaximum + el.Freq.waitMinimum) / 2)} min` : "";
    let tarifsArray = tarifs;
    let getConsultIncidence
    // let pricetag = calcPriceTag(tarifsArray, t);
    const isAproximetePriceElement = icon === 'moto' || icon === 'patinete' || el.name === "Karhoo";
    const isCarTransport = icon === 'taxiVtc';
    const isMetro: boolean = icon === "metro";
    const isCercanias: boolean = icon === "cercanias";
    const externalList = ['EMT', 'CMT', 'CRT', 'TMB', '300', '110'];
    const isExternal = externalList.includes(el.category) || icon === 'busLD' || icon === 'metro' || (!!el.Notes && tarifsArray?.length === 0) /*Si existen notas, el cercanias es external*/
    
    let aproxPrices = getAproxPrices(el?.name, trip, el?.idx);
    if (icon !== "unknwown") {
      let getStatusTrip = {} as any;
      const orderObject = TicketsMap?.find(item => item?.index == el?.idx)

      getStatusTrip = manageStatus(trip, orderObject?.status, orderObject, t);

      const cercaniasWithNotes = !!el?.Notes;
      let tariffObject = TariffMap?.find(item => item?.index == el?.idx) ? TariffMap?.find(item => item?.index == el?.idx) : getPriceTag(icon, aproxPrices, t, cercaniasWithNotes, getStatusTrip);
      let discount=TariffMap?.find((item: any) => item?.allExtraDiscount && item?.index == el?.idx)
      if ((icon === "cercanias" || icon === "ave") && (getStatusTrip.canceled == true && getStatusTrip.status === "CANCELED")) {

        tariffObject = {
          aprox: false,
          isExternal: false,
          price: 0,
          showIcon: false,
          text: "0€",
          type: "info",
          priceTotal:0
        }

      }
      if (!getStatusTrip.state && el.isValidLeg === false) {
        getStatusTrip.state = "warning";
        getStatusTrip.canceled = true;
        getStatusTrip.literal = t("getTripCardData.literals.canceledForMe");
      }

      const buttonsFooter = manageFooterButtons(selectedTarif, icon, orderObject?.bookings,t);
      
      // getStatusTrip = manageActualTripState(orderObject?.bookings, orderObject?.status, t);

      const transportType: ETypeTransport = getTransportType(el);

      let showRemovePlani = el.isValidLeg === undefined && (buttonsFooter || []).length == 0;

      if (el.isValidLeg && icon == 'cercanias' && !orderObject) {
        showRemovePlani = false;
      }

      /* Transbordo entre metros */
      let isMetroTransbordo: boolean = false;
      if (isMetro) {
        const previousTwoSteps = trip.LegList.Leg[index - 2] && switchTransports(trip.LegList.Leg[index - 2]);
        const previousStep = trip.LegList.Leg[index - 1] && switchTransports(trip.LegList.Leg[index - 1]);
        isMetroTransbordo = isMetro &&
          /* Si en dos pasos anteriores es un metro y luego un transbordo a pie */
          previousTwoSteps ?
          previousTwoSteps.icon == "metro" && (previousStep.icon == "andar" || previousStep.icon == "transbordo") :
          /* Si no hay dos pasos anteriores, simplemente el paso anterior es un metro */
          previousStep ?
            previousStep.icon == "metro" :
            false;
      }

    /* Transbordo entre cercanias */
    let isCercaniasTransbordo: boolean = false;
    let isCercaniasIncludedByAve: boolean = false;
    if (isCercanias) {
      const { isTransbordo, isIncludedByAve } = manageTransbordosCercanias(trip, index);
      isCercaniasTransbordo = isTransbordo;
      isCercaniasIncludedByAve = isIncludedByAve;
        if(extractValueByKey(el.Destination?.Notes?.Note,"nc")&& isPastTravel===false ){
        getConsultIncidence={
          nucleo: Number( extractValueByKey(el.Destination.Notes.Note,"nc")),
          date: Number(transformDateIncidents(el.Origin.date)),
        }

    
      }
    }
     
      let preciosInformativos: any =
        isMetroTransbordo ? includedMainText(t, 'getTripCardData.literals.includedMainTicket') :
          isExternal ? externalBuy(t, tariffObject?.price, 'getTripCardData.literals.requiresExternalPurchase') :
            tariffObject;

      /* Cuando es un transbordo o primer cercanias incluido por ave, mostrar billete incluido */
      if (isCercaniasTransbordo || isCercaniasIncludedByAve) {
          preciosInformativos = includedMainText(t)
      }
      //Para los cercanias no controlados por renfe
      if (transportTypeString === ETransportLiterals.train) {
        preciosInformativos = externalBuy(t, tariffObject?.price)
      }

      output.push({
        idPst: index.toString(),
        orderId: orderObject, //selectedTarif[0].orderId,// el indice que ahora es 0 tiene que machear con los que existen en el selected tariff idx
        arrivalTime: [destinationHour, destinationMinutes].join(":"),
        departureTime: [originHour, originMinutes].join(":"),
        direction: (el.Destination === undefined && el.direction === undefined && isCooltra) ? "Cooltra" : (isWalk ? el.Destination?.name : el.direction || el.Destination?.name),
        icon: icon,
        transportTypeString,
        isAproximetePriceElement,
        isCarTransport,
        isExternal,
        transport: isWalk ? false : true,
        frecuency: freq,
        pricetag: preciosInformativos,
        stops: getStops(el),
        showFooter: getStatusTrip.canceled===true ? false: isExternal,
        line: {
          ...line,
          "text": el.name === "karhoo" || el.name === "Karhoo" ? getNameKarhoo(TicketsMap, trip, false) || line.text : line.text,
          "color": line.color //background
        },
        buttonsFooter: getStatusTrip.status==="COMPLETED" ? [] :buttonsFooter,
        cancelled: getStatusTrip.canceled,
        cancelledCheckin: checkAveCanceled(getStatusTrip.canceled, trip.LegList.Leg, selectedTarif, icon, index),
        state: getStatusTrip.state,
        stateLiteral: getStatusTrip.literal,
        classContentButtonsFooter: "justify-content-between",
        duration: `${(diff / 1000 / 60 / 60 > 1 ? Math.floor(diff / 1000 / 60 / 60) + ' h' : '')} ${Math.ceil(diff / 1000 / 60 % 60)} min`,
        showDrivingLicense: el.name === "cooltra" && !isPastTravel,
        literals: el.name === "cooltra" ||el.name === "tier"  ? {
          actionStart: t("getTripCardData.literals.actionStart"),
          actionEnd: t("getTripCardData.literals.actionEnd"),
        } : { action: getActionLiteral(el, t) },
        pricePerTime: getPricePerTime(el, index),
        trip: el,
        tripId: orderObject?.id,
        directionTrip,
        idJourney,
        deleteButtonsActions: { ...deleteButtonsActions, transportType, travellers },
        allExtraDiscount:discount? discount?.allExtraDiscount : undefined,
        variant:isPastTravel=== true ? "myPastTrips":"myTrips",
        getConsultIncidence:getConsultIncidence,
        ...(orderObject?.paymentInfo ? { paymentCard:{...orderObject?.paymentInfo,isPastTravel:isPastTravel} } : {}),
        ...(line.transportTypeString!==ETransportLiterals.train ? { realTimeTrains: getRealTimeTrains(el,icon,line.backgroundcolor, originHour, originMinutes)} : {}),
        ...(isCarTransport === true && TariffMap?.[0].comments!== null ?{comments:TariffMap?.[0].comments} :{} )
      })
    }
  })
  return output;
}


const _getTarifMap = (selectedTarif?: any[],t?:any, trip?:string,t2?:any ) => {

 
  return selectedTarif?.map((item) => {
    const key = item?.idLeg;
    const price = item?.price?.totalWithOutConcepts / 100;
    let infoTicket=[] as any;
    const priceTotal = item?.price?.total / 100;
    const comments=item?.notes?.find((element:any) =>  (item.provider==="movitaxi" ||item.provider==="freenow"  ) && element.type ==="COMMENTS")?.value || null 

    //"COMMENTS"
    if(item?.tickets[0]?.cancellation && Object.entries(item?.tickets[0]?.cancellation).length !== 0){
      if(item?.tickets[0]?.cancellation.fees!==undefined){
        infoTicket.push(
          {
            description:t("desgloseModalLiterals.cancelationfee"),
            price:`${formatPrice((item?.tickets[0]?.cancellation?.fees?.value) /100)} €`,
            color:"canceled-price-desglose"
            },
        )
      }
    }

    //let discount=[]
    //Si es ida y vuelta (tarifa) no metemos el descuento
    if(trip!=="RETURN" && !item?.notes?.find((element:any) => element.type ==="ROUND_TRIP_TARIFF") ){
     //discount = item?.tickets[0]?.price?.concepts?.map((item: any) => {return{description:getDiscountMapping(item.name||item.type,t) ,price:`-${formatPrice((item.value*-1) /100)} €`,}});
  }
  if(item?.tickets[0]?.extras.length!==0){
    item?.tickets[0]?.extras.forEach((ticket:any) => {
      infoTicket.push(
        {
          description:literalExtrasConverter(ticket.type,t2,ticket.value),
          }
      )
    });
  }
    return {
      index: key,
      type: "info",
      text: `${formatPrice(price)} €`,
      isExternal: false,
      showIcon: false,
      aprox: false,
      price: parseFloat(formatPrice(price).replace(',', '.')),
      allExtraDiscount:infoTicket,
      priceTotal:parseFloat(formatPrice(priceTotal).replace(',', '.')),
      estimatedPrice: parseFloat(formatPrice(item?.tickets[0].price.estimatedPrice/100).replace(',', '.')),
      reservationAmount:item?.tickets[0].price.reservationAmount,
      comments:comments
    }
  });
}
const _getTicketsMap = (travellers: any, selectedTarif?: any[],t?:any) => {

  return selectedTarif?.map((item, i) => {
    const key = item.idLeg;
    // const travellersWithBookID = [...travellers[i], travellers[i].bookID = item.tickets[i].idBook]
    return {
      index: key,
      id: item.orderId,
      bookings: item.tickets,
      travellers: getTravellers(selectedTarif[i], travellers),
      status: item.status,
      provider: item.provider,
      paymentStatus:item?.paymentInfo?.paymentStatus ? item?.paymentInfo?.paymentStatus :"ERROR",
      ...(item?.paymentInfo?.paymentMethod ? { paymentInfo: mappingPaymentCards(item?.paymentInfo,item.status,item.provider,item.tickets[0].price,item?.orderFailedReason,t)} : {})
    }
  });
}

const checkAveCanceled = (canceled: any, trip: any, selectedTarif: any, icon: string, index: number) => {
  let result = false
  const stateTicket = ['FAILED', 'CANCELED']


  if (icon == "ingreso" && (RenfeTrainCodesList.includes(trip[index + 1]?.number) && (stateTicket.includes(selectedTarif?.[0]?.tickets?.[0]?.status)))) {
    //True y se aplica css de cancelado
    result = true;
  } else {
    result = canceled;
  }
  return result

}

const manageFooterButtons = (trip: any, icon: string, books?: any,t?:any) => {
  //Si no hay viajes no devolvemos nada

  if (trip === undefined) {
    return [];
  } else {
    switch (icon) {
      case 'cercanias': 
      return !!books ? getCercaniasRenfeButtonsFooter(icon, books) : [];
      case 'ave': 
      if (window.location.pathname === '/app/my-past-trips') {
        return []
      }else{
        return !!books ? getAveRenfeButtonsFooter(icon, books) : [];
      }
      case 'taxiVtc': 
      if(books){
      if (window.location.pathname === '/app/my-past-trips') {
        return []
      }else{
      return getBoltButtonFooter(t);
      }
      }else{
        return []
     }

      default: return [];
    }
  }
}

const getCercaniasRenfeButtonsFooter = (icon: string, books: any) => {
  return [
    {
      "type": "button",
      "styleButton": "outline",
      "id": icon,
      "bookings": books,
      "text": "Ver billete", // ANA: no hay traducción
      "class": "col-auto align-self-start"
    }
  ]
}
const getAveRenfeButtonsFooter = (icon: string, books: any) => {
  return [
    {
      "type": "button",
      "styleButton": "outline",
      "id": icon,
      "bookings": books,
      "text": "Ver billete",
      "class": "col-auto align-self-start"
    },
    {
      "type": "button",
      "styleButton": "link",
      "id": "cancelTrip",
      "text": "Cancelar trayecto", // ANA: no hay traducción
      "class": "col-auto align-self-end"
    }
  ]
}
const getBoltButtonFooter = (t:any) => {
  return [
    {
      "type": "button",
      "styleButton": "link",
      "id": "cancelTrip",
      "text": "",
      "class": "col-auto align-self-start"
    },
    {
      "type": "button",
      "styleButton": "link",
      "id": "cancelTrip",
      "text": t("initialDetailLiteralsAtom.canceled"),
      "class": "col-auto align-self-end"
    }
  ]
}

// function manageActualTripState(bookings: string, status: string, t: any) {
//   let statusObject = {}

//   statusObject = manageStatus(status, bookings, t);
// console.log("Estatus que se va: ", statusObject);

// if(id == undefined){


// }else{

//   RefreshBookStatus(id, (response:any) =>{
//     //console.log("Esta es la respuesta del state", response.data.items[0].status);
//     statusObject = manageStatus(response.data.items[0].status)

//   },(err: any) =>{
//    console.error("Error en la peticion");

//   },{})

// }
// console.log("Este es mi Status Object", statusObject);

//   return statusObject;
// }

function getTicketsStatusObject(element: any, t: any,paymentStatus:string,provider:string) {
  let countFailed = 0;
  let countPending = 0;
  let countCanceled = 0;
  let countStocked = 0;
  let countPendingPayment = 0;
  let countValid=0
  let countByProvider=0
  let countByCompleted=0
  let countCanceledNoRefunded=0
  let countCanceledNoCharge=0
  let countCanceledNotUsed=0
  let statusObject = { state: "", canceled: false, literal: "", status: "",literalFailedReason:"" }


  element.forEach((ticket: any) => {

    if (ticket.status == "FAILED") countFailed++;
    if (ticket.status == "PENDING") countPending++;
    if (ticket.status == "CANCELED") countCanceled++;
    if (ticket.status == "PENDING_PAYMENT") countPendingPayment++;
    if (ticket.status == "VALID") countValid++;
    if (ticket.status == "CANCELED_BY_PROVIDER") countByProvider++;
    if (ticket.status == "COMPLETED") countByCompleted++;
    if (ticket.status == "CANCELED_NON_REFUNDED") countCanceledNoRefunded++;
    if (ticket.status == "CANCELED_NO_CHARGE") countCanceledNoCharge++;
    if (ticket.status == "CANCELED_NOT_USED,") countCanceledNotUsed++;

    

    
    
  });
  //Solo mostramos el mensaje si todos los tickets estan cancelados. 

  if (element.length == countFailed) {
    
    if(provider === "movitaxi"){
    statusObject.literal =t("getTripCardData.literals.movitaxiBookedConfirmed");
    }else{
      statusObject.literal = paymentStatus==="SUCCESS" ?t("getTripCardData.literals.tripFailedSuccess"):t("getTripCardData.literals.canceledProviderDriver");
    }
    statusObject.state = "canceled";
    statusObject.canceled = true;
    statusObject.status = "FAILED"
  } else if (countPending > 0) {
    statusObject.literal = t("getTripCardData.literals.waitingConfirmationFromProviderDriver");
    statusObject.state = "waiting";
    statusObject.canceled = true;
    statusObject.status = "PENDING"
  } else if (element.length == countCanceled) {
    statusObject.literal = t("getTripCardData.literals.canceledForMe");
    statusObject.state = "warning";
    statusObject.canceled = true;
    statusObject.status = "CANCELED"
  }
  else if (element.length == countPendingPayment) {
    statusObject.literal = t("getTripCardData.literals.waitingConfirmationFromProviderDriver");
    statusObject.state = "waiting";
    statusObject.canceled = true;
    statusObject.status = "PENDING"
  }else if(element.length == countValid){
    statusObject.literal = paymentStatus==="SUCCESS" ?t("getTripCardData.literals.tripValidSuccess"):t("getTripCardData.literals.tripValid");
    statusObject.status = "VALID";
    statusObject.state = "valid";
    statusObject.canceled = true;
    
  }
  else if(element.length == countByProvider){
    statusObject.literal = t("getTripCardData.literals.canceledByProvider");
    statusObject.state = "canceled";
    statusObject.canceled = true;
    statusObject.status = "FAILED"
  }else if(element.length == countByCompleted){
    statusObject.state = "";
    statusObject.canceled = false;
    statusObject.literal = "";
    statusObject.status = "COMPLETED";
 
  }
  else if(element.length == countCanceledNoRefunded || element.length == countCanceledNotUsed){
    statusObject.literal = t("getTripCardData.literals.canceledNoRefunded");
    statusObject.state = "waiting";
    statusObject.canceled = true;
    statusObject.status = "PENDING"
 
  }
   else if(element.length == countCanceledNoCharge){
    statusObject.literal = t("getTripCardData.literals.canceledNoCharge");
    statusObject.state = "waiting";
    statusObject.canceled = true;
    statusObject.status = "PENDING"
 
  }


  return statusObject;
}


function manageStatus(trip: any, status: any, bookings: any, t: any) {
  let statusObject = { state: "", canceled: false, literal: "", status: ""}

  if (trip.isValidTrip === false) {
    statusObject.state = "waiting";
    statusObject.canceled = true;
    statusObject.literal = t("getTripCardData.literals.canceledForMe");
    statusObject.status = "CANCELED"
  } else {
    if (!!bookings) {
      statusObject = getTicketsStatusObject(bookings.bookings, t,bookings?.paymentStatus,bookings.provider)
    } else {
      switch (status) {
        case "BOOKED":
          statusObject.state = "";
          statusObject.canceled = false;
          statusObject.literal = "";
          statusObject.status = "BOOKED";
          break;
        case "COMPLETED":
          statusObject.state = "";
          statusObject.canceled = false;
          statusObject.literal = "";
          statusObject.status = "COMPLETED";
          break;
        case "FAILED":
          statusObject.state = "canceled";
          statusObject.canceled = true;
          statusObject.literal = t("getTripCardData.literals.canceledProviderDriver");
          statusObject.status = "FAILED"
          break;
        case "CANCELED":
          statusObject.state = "canceled";
          statusObject.canceled = true;
          statusObject.literal = t("getTripCardData.literals.canceledForMe");
          statusObject.status = "CANCELED"
          break;
        case "PENDING":
          statusObject.literal = t("getTripCardData.literals.waitingConfirmationFromProviderDriver");
          statusObject.state = "waiting";
          statusObject.canceled = true;
          statusObject.status = "PENDING"
          break;
        case "CANCELED_BY_PROVIDER":
            statusObject.literal = t("getTripCardData.literals.canceledByProvider");
            statusObject.state = "canceled";
            statusObject.canceled = true;
            statusObject.status = "FAILED"


          break;
        default:
          break;
      }
    }

  }
  return statusObject;
}


function getTarifs(fareSetItem: Array<IFareSetItem>, contexts: Array<string> = []) {
  const arrayprices: Array<any> = [];

  if (fareSetItem) {
    fareSetItem.forEach(faresetitem => {
      if (faresetitem?.fareItem) {
        faresetitem.fareItem.forEach(fareitem => {
          if (fareitem?.ticket) {
            fareitem.ticket.forEach(ticket => {
              if (contexts.includes(ticket.shpCtx)) { // Si coincide con el context de selectedTariff, se almacena
                if (ticket.cur == "EUR") {
                  arrayprices.push({
                    price: ticket.price / 100,
                    currency: ticket.cur,
                    desc: ticket.desc || ticket.name,
                    param: ticket.param,
                    shpCtx: ticket.shpCtx
                  })
                }
              }
            })
          }
        })
      }
    })
  }
  return arrayprices;
}
/**
 * @description función que calcula el precio de los items del detall
 * @param tarifsArray 
 * @returns 
 */
function calcPriceTag(tarifsArray: any, t: any) {
  return tarifsArray?.length > 0 ? {
    price: tarifsArray[0].price,
    text: `${formatPrice(tarifsArray[0].price)} € - ${tarifsArray[0].desc}`,
    type: tarifsArray.length > 1 ? "button" : "info"
  } : {
    price: 0,
    text: t("getTripCardData.literals.notAvailable"),
    type: "info"
  }
}
function getTransportSection(legs: any, nameTransport: any) {
  const isWalk = legs?.filter((item: any) => (item?.type==="WALK"));
  let output: any = [];
  legs?.forEach((leg: any) => {
    const { diff } = getTimeBetween(leg);
    const item = switchTransports(leg, Math.floor(diff / 1000 / 60), nameTransport)
    // output.push(item);
    if (!(item.icon == "andar" && parseInt(item.text) < 10)) {
      output.push(item);
    }else if(isWalk){
      output.push(item);
    }
    if(item.text?.toLowerCase() == "karhoo"){
      item.text = item.transportTypeString || item.text;
    }
  })
  return output;
}



/* RESUME PAYMENT */

export function getPaymentInfoData(data: IData, detailPrice: any, detailsSelector: any, index: number, fromToData: any, isPastTravel = false, t: any,t2:any) {
  //const selecteditem = data.bookings[index];
  const selecteditem = data;
  const totalObject = _makeSummaryAmount(detailsSelector, detailPrice, isPastTravel, fromToData, data,t2)

  return {
    total: totalObject,
    summary: tripSummary(selecteditem as any, totalObject, isPastTravel, t,t2)
  }
}
/**
 * @description función que calcula el precio del botón de seleccionar viaje
 * @param legs 
 * @returns 
 */ // CREO QUE NO SE USA
export function calcCurrentPrice(legs: any): { sum: number, desc: string } {

  let sum = legs[0]?.pricetag.text;

  return { sum, desc: sum };
}

function getStatusTrip(icon: any, status: any, state: any) {
  if (status != 'canceled') {
    if (icon == 'moto' || icon == 'patinete') return 'noReserved'
    else if (icon == 'taxiVtc') {
      if (state == true) {
        if(status==="waiting"){
          return 'waiting'
        }else if(status==="canceled"){
        return 'canceled'
        }
        else if(status==="stocked"){
          return 'stocked'
          }
      } else {
        if(status!==""){

  
        return 'reserved'
        }
      }

    }
  } else return 'canceled'

}
/*Saco fuera estas variables porque las necesito en otra funcion*/


const _makeSummaryAmount = (tripdetail: Array<any>, detailPrice: any, isPastTravel: boolean, fromToData: any, data:any,t2: any): any => {

  //let isBolt= fromToData.outwardJourney.find((item: any) => item?.transportTypeString === 'Bolt');
  let transportListOutward: TripDetail[] = [], transportListReturn: TripDetail[] = [];
  let onlyTransportListOutward = [] as any, onlyTransportListReturn = [] as any;
  let aproxListOutward = [], aproxListReturn = [];
  let notaproxListOutward = [], notaproxListReturn = [] as any;
  let aproxAmountOutward = 0, aproxAmountReturn = 0;
  let notaproxAmountOutward = 0, notaproxAmountReturn = 0;
  let totalsumOutward = 0, totalsumReturn = 0;


  const results = [] as any;

  transportListOutward = fromToData?.outwardJourney;
  onlyTransportListOutward = transportListOutward?.filter(item => item?.transport && item?.isExternal===false && item?.orderId!==undefined);

  results.push(...onlyTransportListOutward);
  aproxListOutward = transportListOutward?.filter((item: any) => item?.isAproximetePriceElement);
  notaproxListOutward = transportListOutward?.filter((item: any) => !item?.isAproximetePriceElement)
  aproxAmountOutward = aproxListOutward?.reduce((prev: any, current: any) => prev + current?.pricetag?.priceTotal, 0);
  notaproxAmountOutward = notaproxListOutward?.reduce((prev: any, current: any) => prev + current?.pricetag?.priceTotal, 0)
  totalsumOutward = data.outwardJourney.price.total /100;
  //totalsumOutward = data.price.total/100;


  
  if (!!fromToData?.returnJourney) {
    transportListReturn = fromToData?.returnJourney;
    onlyTransportListReturn = transportListReturn?.filter((item: any) => item.transport && item?.isExternal===false && item?.orderId!==undefined);
    aproxListReturn = onlyTransportListReturn?.filter((item: any) => item.isAproximetePriceElement);
    notaproxListReturn = transportListReturn?.filter((item: any) => !item.isAproximetePriceElement)
    aproxAmountReturn = aproxListReturn?.reduce((prev: any, current: any) => prev + current?.pricetag?.priceTotal, 0);
    notaproxAmountReturn = notaproxListReturn?.reduce((prev: any, current: any) => prev + current?.pricetag?.priceTotal, 0)
    totalsumReturn = data.returnJourney.price.total /100; 
    //totalsumReturn = data.price.total/100;
 
    results.push(...onlyTransportListReturn);
 
  }

  let extraIda=getDiscount(fromToData?.outwardJourney,t2)
  let extraVuelta 
  if (!!fromToData?.returnJourney) {
    extraVuelta=getDiscount(fromToData?.returnJourney,t2)
    extraVuelta = extraVuelta.filter((x: undefined) => x !== undefined);
  }

extraIda = extraIda.filter((x: undefined) => x !== undefined);
  const summary = {
    departure: {
      desglose: {
        //now: isBolt ? (!isPastTravel ? `${!!aproxAmountOutward ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(aproxAmountOutward)} €` : null):  (!isPastTravel ? `${formatPrice(notaproxAmountOutward)} €` : null),
        //later: isBolt ? (!isPastTravel ? `${formatPrice(notaproxAmountOutward)} €` : null):(!isPastTravel ? `${!!aproxAmountOutward ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(aproxAmountOutward)} €` : null),
        total: (aproxListOutward?.length == 0 ? `${formatPrice(totalsumOutward)} €` : t2("getTripCardData.literals.approx") + ` ${formatPrice(totalsumOutward)} €`),
        totalOutward: totalsumOutward,
        laterOutward: aproxAmountOutward,
        totalAux:` ${formatPrice(totalsumOutward)} €`
      },
      transports: results?.map((item: any, index:any) => {
    
        let isBolt= item?.transportTypeString === 'Bolt';
        let resultTotal = {};

        if (isBolt) {
            // Si isBolt es verdadero
            resultTotal = (isPastTravel) 
                ? { total: `${formatPrice(item?.pricetag?.price)} €` } 
                : { later: `${t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.estimatedPrice)} €`}; 
        } else {
            // Si isBolt es falso
            if (item.pricetag.redemptionTime) {
              resultTotal = { total: `${formatPrice(item?.pricetag?.price)} €`}; // Mostrar price si redemptionTime existe
            } else {
              resultTotal = { total: `${formatPrice(item?.pricetag?.price)} €`}; // Usar totalWithoutConcepts si no hay redemptionTime
            }
        }
        return item?.isAproximetePriceElement || item?.isCarTransport
          ? {
            transport: item.transportTypeString,
            tripId:item.tripId,
            details: [
              {
                text: _getTextDetails(item, t2),
                typeTrip:item.directionTrip,
                transport: item.transportTypeString,
                external: item?.isExternal,
                alertStatus: getStatusTrip(item.icon, item.state, item.cancelled),
                descriptionSection:item.allExtraDiscount,
                ...(item?.orderId ? {  idLeg:item.orderId.index} : {}),
                index:index,
                totalOutward:item?.pricetag?.price,
                ...(item?.orderId ? {  idLeg:item.orderId.index} : {}), 
                icon:item.icon,
                //...(isBolt===false? {  total:`${(item.icon == 'ave' ? (`${formatPrice(item?.pricetag?.price)} €`) : (item?.pricetag?.text))}`} : {}), 
                //...(isBolt===true ? {  later: isBolt ? (!isPastTravel ? `${formatPrice(item?.pricetag?.price)} €` : null):(isPastTravel ? `${!!item?.pricetag?.price ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.price)} €` : null),} : {}), 
                //price: `${item?.isCarTransport ? "" : t2("getTripCardData.literals.approx")} ${(item?.pricetag?.text)}`,
                //now: isBolt ? (!isPastTravel ? `${!!aproxAmountOutward ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.text)} €` : null):  (!isPastTravel ? `${formatPrice(item?.pricetag?.text)} €` : null), 
                //total:`${(item.icon == 'ave' ? (`${formatPrice(item?.pricetag?.price)} €`) : (item?.pricetag?.text))}`,
                //later: isBolt ? (!isPastTravel ? `${formatPrice(item?.pricetag?.price)} €` : null):(!isPastTravel ? `${!!item?.pricetag?.price ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.price)} €` : null),
              ...resultTotal
        

              }
            ]
          }
          : {
            transport: item.transportTypeString,
            tripId:item.tripId,
            details: [
              {
                text: _getTextDetails(item, t2),
                typeTrip:item.directionTrip,
                external: item?.isExternal,
                alertStatus: getStatusTrip(item.icon, item.state, item.cancelled),
                descriptionSection:item.allExtraDiscount,
                ...(item?.orderId ? {  idLeg:item.orderId.index} : {}), 
                //...(isBolt===false? {  total:`${(item.icon == 'ave' ? (`${formatPrice(item?.pricetag?.price)} €`) : (item?.pricetag?.text))}`} : {}), 
                //...(isBolt===true ? {  later: isBolt ? (!isPastTravel ? `${formatPrice(item?.pricetag?.price)} €` : null):(!isPastTravel ? `${!!item?.pricetag?.price ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.price)} €` : null),} : {}), 
                totalOutward:item?.pricetag?.price,
                index:index,
                icon:item.icon,
                ...resultTotal
                //price: `${(item.icon == 'ave' ? (`${formatPrice(item?.pricetag?.price)} €`) : (item?.pricetag?.text))}`,
                //total:`${(item.icon == 'ave' ? (`${formatPrice(item?.pricetag?.price)} €`) : (item?.pricetag?.text))}`,
                //total:`Hola`,
                //now: isBolt ? (!isPastTravel ? `${!!aproxAmountOutward ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.text)} €` : null):  (!isPastTravel ? `${formatPrice(item?.pricetag?.text)} €` : null),
                //later: isBolt ? (!isPastTravel ? `${formatPrice(item?.pricetag?.price)} €` : null):(!isPastTravel ? `${!!item?.pricetag?.price ? t2("getTripCardData.literals.approx") : t2("getTripCardData.literals.approx")} ${formatPrice(item?.pricetag?.price)} €` : null),
              
    
              }
            ]
          }
      })
    },
  
  }

  return summary;
}
const _getTextDetails = (item: TripDetail, t: any) => {
  return item.isExternal
    ? t("getTripCardData.literals.ticketStation") + `${item?.stops ? item?.stops[0] : ""}`
    : `${item?.line?.text} ${item?.direction}`
}


function tripSummary(data: IBooking, total: any, isPastTravel = false, t:any,t2: any) {
  const arrival = total?.arrival;
  let showButtonDownloadInvoice=false;

if (window.location.pathname === '/app/my-past-trips') {
if(Object.entries(total.departure).length !== 0){
  if(total?.departure?.desglose?.totalOutward!==0){
    let result=getStatusCard(data?.outwardJourney?.selectedTariff, t2)
    if(result.canceled===false){
      showButtonDownloadInvoice=true;
    }
  } 
}else if(Object.entries(total.arrival).length !== 0 && Object.entries(total.departure).length !== 0 ){
  if(total?.departure?.desglose?.totalOutward!==0 ||total?.arrival?.desglose?.totalOutward!==0){
    let result=getStatusCard(data?.outwardJourney?.selectedTariff, t2)
    if(result.canceled===false){
      showButtonDownloadInvoice=true;
    }
  } 
}
}

const results = [];

if (data.outwardJourney) {
  results.push(...mappindDesglose(data.outwardJourney, data.createdDate,data.travellers,"outwardJourney",t));
}

if (data.returnJourney) {
  results.push(...mappindDesglose(data.returnJourney, data.createdDate,data.travellers, "returnJourney",t));
}


return filterRenfeTrip(results).map((item:any, index:any) => {
  return {...item,index}
}) as any;
 

}

function getAproxString(aproxOutward: number, aproxReturn: number, t: any) {
  if (aproxOutward + aproxReturn != 0) return t("getTripCardData.literals.approx")
  else return ""
}
function totalTickets(data: IBooking) {
  const { outwardJourney, returnJourney } = data;
  let suma = 0;
  suma += getPriceTicketsTotal(outwardJourney);
  suma += returnJourney ? getPriceTicketsTotal(returnJourney) : 0;
  return suma;
}

function totalAmount(data: IBooking) {
  return totalTickets(data);
}

function getPriceTicketsTotal(data: IJourney) {
  const contextsBooked: Array<string> = mapContextsBooked(data);
  const prices = searchTicketsPrice(data, contextsBooked);
  let suma = 0;
  prices?.forEach(element => suma += element);
  return suma;
}

// OK
function mapContextsBooked(data: IJourney): Array<string> {
  if (data && data.selectedTariff) {
    const contexts: Array<string> = [];
    data.selectedTariff?.forEach((item: any) => {
      item?.tickets?.forEach((ticket: any) => contexts.push(ticket.context)); // devuelve un array
    })
    return contexts;
  } else {
    return []
  }
}
// OK
function searchTicketsPrice(data: IJourney, contexts: Array<string>) {
  const arrayprices: Array<any> = [];
  if (data?.trip?.TariffResult?.fareSetItem) {
    data.trip.TariffResult.fareSetItem.forEach(faresetitem => {
      if (faresetitem?.fareItem) {
        faresetitem.fareItem.forEach(fareitem => {
          if (fareitem?.ticket) {
            fareitem.ticket?.forEach(ticket => {
              if (contexts.includes(ticket.shpCtx)) {
                arrayprices.push(ticket.price / 100);
              }
            })
          }
        })
      }
    })
  }

  return arrayprices;
}



export function getNameKarhoo(book: any, trip: any, isToday: boolean) {
  let contextBook: any; let result = ""


  if (isToday == true) {


    if (trip?.LegList?.Leg?.[0]?.name === "karhoo" || trip?.LegList?.Leg?.[0]?.name === "Karhoo" && (book.outwardJourney?.selectedTariff != undefined && trip.TariffResult != undefined)) {
      contextBook = book.outwardJourney.selectedTariff[0].tickets[0].context;
      trip?.TariffResult?.fareSetItem[0]?.fareItem[0].ticket.forEach((element: any) => {
        if (contextBook === element.shpCtx) {
          result = element.name
        }
      });
    }
  } else {
    if (trip.LegList.Leg?.[0]?.name === "karhoo" || trip.LegList.Leg?.[0]?.name === "Karhoo" && (book != undefined && trip.TariffResult != undefined)) {
      contextBook = book[0].bookings[0].context;
      trip?.TariffResult?.fareSetItem[0]?.fareItem[0].ticket.forEach((element: any) => {
        if (contextBook === element.shpCtx) {
          result = element.name
        }
      });
    }
  }
  return result
}

function externalBuy(t: any, price: number = 0, literal: string = 'getTripCardData.literals.requiresExternalPurchase') {
  return {
    price: 0,
    text: `${t(literal)} (${price ? formatPrice(price) + '€' : t('getTripCardData.literals.requiresExternalPurchaseNoPrice')})`,
    type: "warn"
  }
}

const filterWalkingCards = (transportsArray: Array<any>) => {
  const arrayFinal =  transportsArray.length === 1 ? transportsArray : transportsArray.filter((item: any) => !(item.icon == "andar" && parseInt(item.text) < 10))
  return arrayFinal;
}


/**
 * @description get trip list
 * @param callback 
 * @param errorCallback 
 */
export function getCancellationConditionsCall(body: any,orderId:string, callback: Function, errorCallback: Function) {
  
    const apiWithParams = `/journeys/${orderId}`;
    postAxios(apiNames.BKING, true, apiWithParams,body).then((data: any) => {
      /*const mock={
        "data": {
            "orderNumber": "O-000AGT",
            "bookingId": "YXZlbGR8aWR8MC4xfC9nYk0vWU9sZ0FnQXVxc25uak1vQ0E9PXx7ImlkIjoiNVJTVjdXIn0=",
            "provider":"renfe-ave",
            "description": "AVE LD Ticket Reference",
            "bookingTime": "2023-07-17T09:46:26.837Z",
            "ticketId": "2c5eb986-5b3d-4384-aed1-d1427591af21",
            "entitlement_id": "66417fc5-64de-4597-a6cb-46e74160bf13",
            "price": {
                "amount": 2115,
                "currency": "EUR"
            },
          "cancellationInformation": {
                "cancelable": "true|false",
                "cancellationFees": {
                    "amount": 0,
                    "currency": "EUR"
                }
            }
        }
      }*/
      callback(data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  
}